import { History } from 'history';
import useComponentMount from '../hooks/useComponentMount';
import { USERS_PER_PAGE } from '../../utils/constants';
import usePagination from '../../components/Pagination/hooks/usePagination';
import { GET_USERS_V3 } from '../../apollo/queries/v3/getUsersV3.queries';
import appLocalStorage from '../../utils/AppLocalStorage';

interface LocationState {
  pageNumber: number;
}

interface Props {
  history: History;
}

const useMembersPage = ({ history }: Props) => {
  const pageNumber = history.location.state
    ? (history.location.state as LocationState).pageNumber
    : 1;

  const {
    queryData: { loading, error, data, refetch },
    pageData: {
      currentPage,
      search,
      totalPages,
      totalCount,
      pageSize,
      pageStats,
    },
    actions: { setCurrentPage, setSearch, setPageSize, onSearch },
  } = usePagination({
    query: GET_USERS_V3,
    responseField: 'usersV3',
    pageSize: USERS_PER_PAGE,
    currentPage: pageNumber,
  });

  const isComponentMounted = useComponentMount();

  const resetPagination = () => {
    setCurrentPage(1);
  };

  const onSearchChange = (value: string) => {
    resetPagination();
    onSearch(value);
  };

  const onPageSizeChange = (size: number) => {
    setPageSize(size);
  };

  return {
    search,
    isViewOnlyRole: appLocalStorage.isViewOnlyRole(),
    onSearchChange,
    setCurrentPage,
    setSearch,
    refetch,
    userData: {
      currentPage,
      loading,
      error,
      users: data && data.usersV3 ? data.usersV3.users : [],
      pageNumber,
      totalPages,
      totalCount,
      pageSize,
    },
    onPageSizeChange,
    pageStats,
    isComponentMounted,
  };
};

export default useMembersPage;
